<template>
    <div :class="['toast-container', {'restart-animation': updated}]">
        <slot />

        <notification
            v-for="(toast, index) in toasts"
            :key="index"
            :variant="`toast ${toast.type || 'info'}`"
            :show="true"
            :auto-dismiss="true"
            :message="toast.message"
            @dismissed="onToastDismiss(toast)"
        />
    </div>
</template>

<script>
    import Notification from './Notification';

    export default {
        name: 'Toaster',

        components: { Notification },

        data: () => (
            {
                toasts: [],
                updated: false
            }
        ),

        mounted() {
            this.$bus.$on('toast', (toast) => {
                this.toasts.push(toast);
                this.updated = true;
                this.updated = false;
            });
        },

        methods: {
            onToastDismiss(toast) {
                this.toasts.filter(item => item !== toast)
            }
        }
    }
</script>
